import React from 'react';
import {
    isMobile,
    useWindowSize,
} from '@frontend/jetlend-web-ui/src/utils/responsive';
import { getAssetSrc } from '@frontend/jetlend-web-ui/src/utils/getAssetSrc';
import Image from '@app/components/Image/Image';
import Section from '@app/ui/Section/Section';
import cupIcon from '@app/icons/cup.svg';
import background from '@app/icons/academy/academy_promotion2.jpg';
import backgroundMobile from '@app/icons/academy/academy_promotion_mob2.jpg';
import PromotionCourseSection from '@app/features/academy/main/FooterSection/PromotionCourseSection/PromotionCourseSection';
import { IPromotionCourseApiModel } from '@app/models/features/course';

import styles from './PromotionSection.module.scss';

export interface IProps {
    /**
     * Информация о рекламном курсе
     */
    promotionCourse: IPromotionCourseApiModel;
}

/**
 * Компонент для отрисовки рекламной секции академии
 * Рекламный блок и реклама конкретного курса
 */
const PromotionSection:React.FC<IProps> = props => {
    const { promotionCourse } = props;
    const { width: screenWidth } = useWindowSize();
    const isMobileScreen = isMobile(screenWidth);
    const containerBackground = isMobileScreen ? backgroundMobile :  background;

    return (
        <Section animation={false}>
            <div className={styles['container']} style={{ backgroundImage: `url(${getAssetSrc(containerBackground)})` }}>
                <div />
                <div className={styles['info']}>
                    <div>
                        <div className={styles['image-block']}>
                            <Image src={cupIcon} alt="" width={18} height={18} />
                        </div>
                        <div className={styles['grey-text']}>20+ наград</div>
                    </div>
                    <div className={styles['title']}>Получайте награды за прохождение</div>
                </div>
            </div>
            <PromotionCourseSection classNames={styles['promotion-course']} promotionCourse={promotionCourse} buttonText="Зарегистрироваться" buttonUrl="/invest/register/?return_uri=/academy" />
        </Section>
    );
};

export default PromotionSection;